import { Component, OnInit} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../../services/general.service';
import { UsersService } from '../../../services/users.service';
import { ProvidersService } from '../../../services/providers.service';
import {UserComponent} from '../user/user.component';
import {ModalConfirmComponent} from '../../../modal-confirm/modal-confirm.component';
import * as decode from 'jwt-decode';
import * as XLSX from 'xlsx';
// tslint:Insert-next-line: IN_HCR20200831
import { TranslateService } from 'ng2-translate/ng2-translate';


@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
  userId: any;
  userToken: any;
  listUsers = [];
  temp = [];
  listProviders: any = [];
  listProfiles: any;
  load = true;

  constructor(private toastr: ToastrService,
              public dialog: MatDialog,
              private gralService: GeneralService,
              private provService: ProvidersService,
              private usersService: UsersService,
              // tslint:insert-next-line: IN_HCR20200831
              public  translate: TranslateService) {
                translate.addLangs(['es', 'en']);
                translate.setDefaultLang('es');
               // tslint:insert-next-line: END_HCR20200831

    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);
    this.userId = tokenPayload.Id;
    this.getProviders();
    this.getProfiles();
    this.getUsers();
    gralService.changeTextHead('USERS');
  }

  ngOnInit() {
  }



  getUsers(){
    this.usersService.getUsers(this.userToken).then((data) => {
      this.listUsers = data['Entidades'];
      this.temp = data['Entidades'];
      this.load = false;
      this.reorderList();
    }, (err) => {
      console.log(err);
      this.load = false;
      this.listUsers = null;
      this.toastr.error(err['error'].msg, 'Error al cargar lista de usuarios');
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  getProfiles(){
    this.gralService.getProfiles(this.userToken).then((data) => {
      this.listProfiles = [];
      for(let g = 0; g < data['Entidades'].length; g++){
        if(data['Entidades'][g].Activo){
          this.listProfiles.push(data['Entidades'][g]);
        }
      }
    }, (err) => {
      console.log(err);
      this.listProfiles = null;
      this.toastr.error(err['error'].msg, 'Error al crear usuario');
    });
  }

  getProfile(id){
    const profile = this.listProfiles.find(x => x.IdPerfil == id);
    return profile.Nombre;
  }

  getProviders(){
    this.provService.getProviders(this.userToken).then((data) => {
      this.listProviders = data['Entidades'];
    }, (err) => {
      console.log(err);
      this.listProviders = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();
    // filter our data
    const temp = this.temp.filter(function(d) {
      console.info(d.Nombre)
      let ret = d.Nombre.toLowerCase().indexOf(val) !== -1 || !val;
      // if(d.Apellidos){
      //   ret = ret+d.Apellidos.indexOf(val) !== -1 || !val;
      // }
      if(d.Email){
        ret = ret+d.Email.toLowerCase().indexOf(val) !== -1 || !val;
      }
      ret = ret+d.Usuario.toLowerCase().indexOf(val) !== -1 || !val;
      // ret = ret+d.Perfil.toLowerCase().indexOf(val) !== -1 || !val;
      return ret;
    });
    // update the rows
    this.listUsers = temp;
  }

  add(){
    const dialogRef = this.dialog.open(UserComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: { type: 'add', userToken: this.userToken, profiles: this.listProfiles, providers: this.listProviders }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.listUsers.push(result['data']);
      }
    });
  }

  edit(id, idx){
    this.usersService.getUser(id, this.userToken).then((data) => {
      const dialogRef = this.dialog.open(UserComponent, {
        minWidth: '50%',
        position: {
          top: '6%'
        },
        data: { type: 'edit', id: id, info: data['Entidad'], userToken: this.userToken, profiles: this.listProfiles, providers: this.listProviders }
      });

      dialogRef.afterClosed().subscribe(result => {
        if(result){
          this.listUsers[idx] = result['data'];
        }
      });
    }, (err) => {
      console.log(err);
      this.toastr.error(err['error'].msg, 'Error en modulo usuarios');
    });
  }

  changePass(id, idx){
    const retT = this.listUsers.find(x => x.id === id);
    console.log(retT.Usuario);

    this.dialog.open(UserComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: { type: 'password', id: id , userToken: this.userToken, profiles: this.listProfiles, username: retT.Usuario  }
    });
  }


  changeStatus(id, status, idx){


    let dataa = {};
    if(!status){
      //dataa = { type: 'delete', id: id, button: 'Desactivar', title: 'Desactivar usuario', content: '¿Esta seguro de deactivar este usuario?', icon: 'warning' };
      dataa = { type: 'delete',
                id: id,
                button:   this.translate.instant('BUTTONS.DEACTIVATE'),
                title:    this.translate.instant('FORMS.DESUSER'),
                content:  this.translate.instant('FORMS.CONDESUSER'),
                icon: 'warning' };
    }else{
      //dataa = { type: 'active', id: id, button: 'Activar', title: 'Activar usuario', content: '¿Esta seguro de activar este usuario?', icon: 'warning' };
      dataa = { type: 'active',
                id: id,
                button:   this.translate.instant('BUTTONS.ACTIVATE'),
                title:    this.translate.instant('FORMS.ACTUSER'),
                content:  this.translate.instant('FORMS.CONACTUSER'),
                icon: 'warning' };
    }


    const dialogRef = this.dialog.open(ModalConfirmComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: dataa
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        const params = {Activo: status, Usuario: this.listUsers[idx].Usuario};
        this.usersService.statusUser(id, params, this.listUsers[idx].id, this.userToken).then(data => {
          this.listUsers[idx].Activo = status;
          this.toastr.success('Se cambio el estatus del usuario correctamente', 'Cambiar estatus');
        }, (err) => {
          console.log(err);
          this.toastr.error('Error al cambiar estatus del usuario', 'Cambiar estatus');
          if(err.status == 401){
            this.gralService.actDeacUser(false);
          }
        });
      }
    });
  }

  toExportFileName(excelFileName: string): string {
    return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
  }

  public exportAsExcelFile(): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.list);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    XLSX.writeFile(workbook, this.toExportFileName('usuarios'));
  }

  list = [];
  reorderList(){
    this.listProviders = [];
    let lista = this.listUsers;

    for(let i = 0; i < lista.length; i++){
      let perfil;
      if(lista[i].IdPerfil == 1 ){ }
      else if(lista[i].IdPerfil == 2 ){ }
      let params = {
        "Nombre": lista[i].Nombre,
        "Correo": lista[i].Email,
        "Usuario": lista[i].Usuario,
        "Perfil": this.getProfile(lista[i].IdPerfil),
        "Estatus": (lista[i].Activo)? 'Activo': 'Inactivo',
        "Primer acceso": (lista[i].ValidarDatosProveedor)? 'No': 'Si'
    }

    this.list.push(params);
    }

  }


}
